module.exports = __webpack_public_path__ + "media/images/iconUp__inFrontOfAccent-b911257442952e09f4396715c270f7df.png";